
export default function BlogStandard() {
  return (
<><h1>Not Found</h1>
<p>The requested URL was not found on this server.</p></>
      );
}